import * as React from "react";
import styled from "styled-components";
import { formatDateTime } from "../../shared/dateTimeUtils";
import { AHI_IMAGES } from "./constants";
import "./ahi.scss";

export function launchAhiSystemFn({ data, url, postOpsLog }) {
  return (e) => {
    e.stopPropagation();
    postOpsLog({
      operationType: "launchAHI",
      extraContext: {},
    });
    window.open(url || data.ahiWebAppSPV, "_blank", "noopener,noreferrer");
  };
}

const AhiScore = ({ data, postOpsLog }) => {
  /** ************************************************* SETUP *************************************************** */

  /** ************************************************* HOOKS *************************************************** */

  /** *********************************************** FUNCTIONS ************************************************* */

  const launchAhiSystem = launchAhiSystemFn({ data, postOpsLog });

  /** ************************************************* RENDER ************************************************** */

  return (
    <Wrapper onClick={launchAhiSystem}>
      <Section>
        <AhiTitle>AHI-PI</AhiTitle>
        <StyledImg src={AHI_IMAGES[data.ahiPi]} />
        <AhiLabel>{data.ahiText}</AhiLabel>
      </Section>
      <Section>
        <Column>
          <RiskText>{data.ahiType}</RiskText>
          <RiskText>{formatDateTime(data.ahiWindowEnd)}</RiskText>
        </Column>
      </Section>
    </Wrapper>
  );
};

export default AhiScore;

/** ************************************************* STYLES ************************************************** */

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  height: 28px;
`;

const Section = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const AhiTitle = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.4px;
  padding-left: 4px;
`;

const AhiLabel = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
`;

const StyledImg = styled.img`
  height: 28px;
  width: 28px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 4px;
  padding-top: 2px;
`;

const RiskText = styled.div`
  color: rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  font-size: 9px;
`;
